import { Box, Divider, Stack } from '@mui/material'
import { memo } from 'react'

import { Image } from 'src/components/shared/image'
import { Label } from 'src/components/shared/label'
import SubmitButton from 'src/components/shared/button/SubmitButton'
import Text from 'src/components/shared/text/Text'

const ClaimStakingRewardCard = ({
  t,
  symbol,
  value,
  icon,
  tier: { name },
  onClaimReward,
  bonusCondition,
  disableAction
}) => {
  return (
    <Box
      sx={{
        bgcolor: 'background.neutral',
        borderRadius: 1.5
      }}
    >
      <Box
        sx={{
          gap: 1,
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Image src={icon} sx={{ maxHeight: 100, aspectRatio: '1/1' }} />
        <Box>
          <Stack spacing={2} alignItems='flex-end' flexWrap='wrap'>
            <Text variant='h4' label={value} sx={{ lineHeight: 1 }} />
            <Label color='primary'>{`${name}: ${bonusCondition}`}</Label>
          </Stack>
        </Box>
      </Box>
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Stack
        sx={{
          p: 2,
          alignItems: 'flex-end'
        }}
      >
        <SubmitButton
          label={t('brand:staking.claim-reward', { symbol })}
          type='button'
          onClick={() => onClaimReward(symbol)}
          disabled={disableAction}
          size='small'
        />
      </Stack>
    </Box>
  )
}

export default memo(ClaimStakingRewardCard)
